import { render } from "./daily-fund-chart.vue?vue&type=template&id=5d87c970"
import script from "./daily-fund-chart.vue?vue&type=script&lang=ts"
export * from "./daily-fund-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script